/**
 * Created by mauget on 3/1/16.
 */

// OpenViewableInstanceDetailView.js

import $ from 'jquery';
import { View, Model } from 'backbone';
import PlayFormModal        from 'common-views/PlayFormModal.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/forms/viewable-instance-detail-view.ejs';
import BaseTableView from 'properties/BaseTableView.js';
import util from 'util/Util.js';
import restService      from 'RestService.js';
import eventBus  from 'EventBus';
import RestService from "../../../service/RestService";
import DataHistoryModal from "../../common-views/DataHistoryModal";


class ViewableInstanceDetailView extends BaseTableView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = contentTemplate;
        this.gridEl = constants.PROP_MAIN_TABLE;

        this.events = {
            'click #viewInstance' : 'viewInstance',
            'click #viewData'     : 'viewData', 
            'click #goToForms': 'goToForms',
            'click #goToEditForms': 'goToEditForms'
        };

        this.model.set({
            colModel: [
                {
                    name: 'date',
                    index: 'date',
                    editable: false
                },
                {
                    name: 'time',
                    index: 'time',
                    editable: false
                },
                {
                    name: 'title',
                    index: 'title',
                    editable:false
                },
                {
                    name: 'role',
                    index: 'role',
                    editable:false
                },
                {
                    name: 'attentionLevel',
                    index: 'attentionLevel',
                    editable: false
                },
                {
                    name: 'notificationId',
                    index: 'notificationId',
                    editable: false,
                    hidden: true
                }

            ],
            colNames: ['Date', 'Time', 'Title','Role','AttentionLevel', 'notificationId']
        });

        this.listenTo(this.model, 'change', this.render);
        this.onResize();

        return this;
    }

    viewInstance() {
        const selRowId = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        const rowData = $(this.gridEl).getRowData(selRowId);

        const instanceUrl = restService.getLinkUrl(rowData['notificationId']) + '&viewForm=true';
        const attributes = {url: instanceUrl, id: rowData['notificationId'] };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        newPlayForm.render().then((result) => {});
    }

    viewData() {
        const instanceId = this.model.get('instanceId');

        if(!instanceId){
            return;
        }

        RestService.getFormDataHistory(instanceId).then((data)=>{
            const attributes = {subtitle:'Data History - ' + this.model.get('formName') + ' (' + this.model.get('firstSubmissionDate') + ')' ,
                dataHistory: data};
            let newDataHistoryForm = new DataHistoryModal({model: new Model(attributes) });
            newDataHistoryForm.render().then((result) => {
            }).catch((err)=> {
                console.log('Error in Data History', err);
            });
        });

    }

    onCellSelect(rowId, iCol, cellContent,e){
        $(this.gridEl).jqGrid('setSelection',rowId);
        $("#viewInstance").prop('disabled',false);
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    render() {
        this.onRender();
        var gridData = this.model.get('gridData');
        console.log('This is the gridData',gridData);

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var self = this;
        let gridObject=util.getGridObject(self);
        $(self.gridEl).jqGrid(gridObject);
        if(gridData) {
            gridData.forEach(function (value, index) {
                var newRow = {
                    'date': util.toLocalDateTime( value['@NotificationDate'], 'DD MMM YYYY'),
                    'time': util.toLocalDateTime( value['@NotificationDate'], 'HH:MM'),
                    'title': value['@Name'],
                    'role': value['@RoleName'],
                    'attentionLevel': util.getAttentionLevel(value["@AttentionLevel"]),
                    'notificationId': value['@NotificationId']
                };
                $(self.gridEl).addRowData(index, newRow);//
            });
        }

        if (this.config) {
            if (this.config.showTitle) {
                this.$el.find('.propTitle').removeClass('hide');
            }
        }


        $('#detailHeading').html('App-Instance');

        this.resizeGrid();
        this.delegateEvents();

        this.afterRender();
        this.$el.css('cursor', 'default');
        return this;
    }

    goToForms(e) {
         e.preventDefault();
         e.stopPropagation();
 
         eventBus.trigger("loadFormsView");
     }
 
    goToEditForms(e) {
         e.preventDefault();
         e.stopPropagation();
 
         eventBus.trigger("displayDefaultEditFormsDetailView");        
    }
}

export default ViewableInstanceDetailView;

